import React from 'react';

export const STATUS_COLOURS = { green: '#2e7d32', amber: '#c9a13b', red: '#b3261e', neutral: '#7c7560' };

// Semi-circular dial. value is a percentage (0-100) unless max is given.
export function Dial({ value, max = 100, status = 'neutral', size = 120, unit = '%', label, testid, dark = false }) {
  const fg = dark ? 'var(--cream)' : 'var(--ink)';
  const txt = dark ? 'var(--cream)' : 'var(--navy)';
  const track = dark ? 'rgba(255,255,255,0.12)' : 'rgba(0,0,0,0.08)';
  const r = size / 2 - 10;
  const cx = size / 2, cy = size / 2;
  const pct = value == null ? 0 : Math.max(0, Math.min(1, value / max));
  const arc = (from, to, colour, width) => {
    const a0 = Math.PI * (1 - from), a1 = Math.PI * (1 - to);
    const x0 = cx + r * Math.cos(a0), y0 = cy - r * Math.sin(a0);
    const x1 = cx + r * Math.cos(a1), y1 = cy - r * Math.sin(a1);
    const large = to - from > 0.5 ? 1 : 0;
    return <path d={`M ${x0} ${y0} A ${r} ${r} 0 ${large} 1 ${x1} ${y1}`} stroke={colour} strokeWidth={width} fill="none" strokeLinecap="round" />;
  };
  const colour = STATUS_COLOURS[status] || STATUS_COLOURS.neutral;
  const needle = Math.PI * (1 - pct);
  return (
    <svg width={size} height={size / 2 + 18} viewBox={`0 0 ${size} ${size / 2 + 18}`} data-testid={testid} role="img" aria-label={`${label || ''} ${value == null ? 'no data' : value + unit}`}>
      {arc(0, 1, track, 10)}
      {pct > 0 && arc(0, pct, colour, 10)}
      <line x1={cx} y1={cy} x2={cx + (r - 16) * Math.cos(needle)} y2={cy - (r - 16) * Math.sin(needle)} stroke={fg} strokeWidth={2.5} strokeLinecap="round" />
      <circle cx={cx} cy={cy} r={4} fill={fg} />
      <text x={cx} y={cy + 16} textAnchor="middle" fontFamily="var(--font-title)" fontSize={size / 6} fill={txt}>
        {value == null ? '—' : `${value}${unit}`}
      </text>
    </svg>
  );
}

export function Sparkline({ points = [], width = 220, height = 48, colour = 'var(--navy)' }) {
  const vals = points.map((p) => (p.value == null ? null : Number(p.value)));
  const real = vals.filter((v) => v != null);
  if (real.length < 2) return <p className="text-xs" style={{ color: 'var(--olive)' }}>Trend appears after a few days of readings.</p>;
  const min = Math.min(...real), max = Math.max(...real);
  const span = max - min || 1;
  const step = width / (vals.length - 1);
  const d = vals.map((v, i) => (v == null ? null : `${i * step},${height - 4 - ((v - min) / span) * (height - 8)}`)).filter(Boolean).join(' ');
  return (
    <svg width={width} height={height} viewBox={`0 0 ${width} ${height}`} data-testid="ops-sparkline">
      <polyline points={d} fill="none" stroke={colour} strokeWidth={2} strokeLinejoin="round" strokeLinecap="round" />
    </svg>
  );
}
